import React from "react";
import { useAuth } from "./../util/auth";
import { Box } from "@material-ui/core";
import { Container } from "@material-ui/core";

const BiometricInfo = () => {
  const auth = useAuth();
  const formUrL = `https://airtable.com/embed/shrxdOkpp4fDnAFeg?prefill_Firebase_ID=${auth.user.id}&backgroundColor=green`;

  return (
    <Box mt={3}>
      <Container maxWidth="sm">
        <iframe
          className="airtable-embed"
          title="inital-form"
          src={formUrL}
          frameBorder="0"
          width="100%"
          height="533"
        ></iframe>
      </Container>
    </Box>
  );
};
export default BiometricInfo;
